import HotelTransport from '@/views/HotelTransport/index.vue'

const HotelTransportRouter = {
  path: '/hotel-transport',
  name: 'HotelTransport',
  component: HotelTransport,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default HotelTransportRouter
